import React, { useEffect, useState } from "react";
import { useLoadPostIdsData } from "../../Utils/customHooks/UpToDateContent/useLoadPostIdsData";

import Skeleton from "react-loading-skeleton";
import "./RemovedContent.css";
import PostCardComponent from "./PostCardComponent";
import ProductTitle from "./ProductTitle";

const RemovedContentTable = (props: any) => {
  const {
    username,
    user_id,
    post_ids,
    componentName,
    refetchDashboard,
    setRemovePostIds,
    type,
    displayName,
    removePostIds,
    contentData,
    refetchLinks,
    edit,
    setEdit,
    editIndex,
    setEditIndex,
    isActionLoading,
    setIsActionLoading,
    order,
    handleFeed,
    isPodcast
  } = props;

  const [localPosts, setLocalPosts] = useState<any[]>([]);
  const [deletePostIds, setDeletePostIds] = useState(removePostIds);

  const {
    isLoading: PostIdFeedLoading,
    data: PostIdData,
    refetch: PostIdDataRefetch,
  }: any = useLoadPostIdsData(username, user_id, deletePostIds?.split(","), props?.platform);
  useEffect(() => {
    setDeletePostIds(removePostIds);
  }, [removePostIds]);

  useEffect(() => {
    if (PostIdData) {
      const filteredPosts = PostIdData.filter(
        (element: any) => element !== undefined
      );

      if (order === "newest") {
        filteredPosts.sort(
          (a: any, b: any) =>
            new Date(b.post_date).getTime() - new Date(a.post_date).getTime()
        );
      } else if (order === "oldest") {
        filteredPosts.sort(
          (a: any, b: any) =>
            new Date(a.post_date).getTime() - new Date(b.post_date).getTime()
        );
      }

      setLocalPosts(filteredPosts);
    }
  }, [PostIdData, order]);

  const onAdd = async (post_id: string) => {
    setIsActionLoading(true);
    try {
      // Update local state immediately
      setLocalPosts((prev) => prev.filter((post) => post.post_id !== post_id));

      // If the post was in removePostIds, remove it
      if (removePostIds?.includes(post_id)) {
        setDeletePostIds((prev: any) => {
          const idsArray = prev?.split(",").filter(Boolean);
          const filteredArray = idsArray?.filter(
            (elem: any) => elem !== post_id
          );
          return filteredArray.join(",");
        });
        await props.handleRemovedPostIds(post_id, "add");
      }
    } finally {
      setIsActionLoading(false);
    }
  };

  const [value, setValue] = useState<string>();



  const SkeletonStatBox = () => {
    return (
      <div className="skeleton-stat">
        <Skeleton className="skeleton-style" />
      </div>
    );
  };

  if (!PostIdFeedLoading && (!localPosts || localPosts.length === 0)) {
    return null;
  }

  return (
    <>
      <div className="removed-content">
        <label className="bold-label fontsize-12">Removed Content</label>
        <div className="removed-content-container">
          <div className="added-content">
            {PostIdFeedLoading ? (
              <div className="skeleton-stat-box">
                {[...Array(3)].map((_, index) => (
                  <SkeletonStatBox key={index} />
                ))}
              </div>
            ) : (
              localPosts.map((post: any, index: any) => (
                <React.Fragment key={post.post_id}>
                  <div className="feed-tab-post-container post-container">
                    <PostCardComponent
                      post={post}
                      onMinus={onAdd}
                      from="removed"
                      isPodcast={isPodcast || post?.platform == "podcast"}
                      isYoutube={false}
                    />
                    <ProductTitle post={post} type={type} />
                  </div>
                </React.Fragment>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RemovedContentTable;
